<template>
	<div class="warehouse-index">
		<div class="empty-guide" v-if="ready && !hasApply">
			<div class="empty-title">您还未开通云仓</div>
			<div class="empty-desc">开通后可缴纳保证金，后续接入在仓库存、销售记录和入仓管理。</div>
			<el-button type="primary" @click="goApply">申请开通云仓</el-button>
		</div>

		<div class="status-card" :class="'state-' + apply.state" v-if="ready && hasApply && apply.state != 2">
			<div class="status-head">
				<span class="name">{{ apply.name || '云仓申请' }}</span>
				<span class="state-tag">{{ apply.state_str }}</span>
			</div>
			<div class="status-row">保证金：¥{{ fenToYuan(displayDepositFen) }}{{ depositRefundTip }}</div>
			<div class="status-row" v-if="apply.create_time_str">申请时间：{{ apply.create_time_str }}</div>
			<div class="status-row" v-if="apply.audit_time_str">审核时间：{{ apply.audit_time_str }}</div>
			<div class="remark" v-if="apply.state == 3 && apply.audit_remark">审核备注：{{ apply.audit_remark }}</div>
			<div class="status-actions">
				<el-button v-if="apply.state == 1" size="small" :loading="canceling" @click="onCancel">撤回申请</el-button>
				<el-button v-if="apply.state == 3 || apply.state == 4 || apply.state == 5" type="primary" size="small" @click="goApply">{{ apply.state == 5 ? '重新开通' : '重新申请' }}</el-button>
			</div>
		</div>

		<div class="opened" v-if="ready && apply.state == 2 && info.id">
			<div class="card">
				<div class="card-title">
					<span>云仓信息</span>
					<el-button size="small" @click="openMarkup">修改默认加价</el-button>
				</div>
				<div class="info-grid">
					<div><span>名称</span>{{ info.name }}</div>
					<div><span>地址</span>{{ info.address }}</div>
					<div><span>联系人</span>{{ info.contact_name }}</div>
					<div><span>电话</span>{{ info.contact_mobile }}</div>
					<div><span>开通时间</span>{{ info.create_time_str }}</div>
					<div><span>状态</span>{{ info.state_str }}</div>
					<div><span>默认加价</span>{{ formatMarkupDiscount(info.markup_discount) }}</div>
				</div>
			</div>

			<div class="card">
				<div class="card-title">
					<span>保证金</span>
					<div>
						<el-button type="primary" size="small" @click="openRecharge">补充保证金</el-button>
						<el-button size="small" @click="goLog">保证金流水</el-button>
					</div>
				</div>
				<div class="money-grid">
					<div class="money-item">
						<div class="label">保证金总额</div>
						<div class="value">¥{{ fenToYuan(info.deposit_amount) }}</div>
					</div>
					<div class="money-item">
						<div class="label">冻结金额</div>
						<div class="value">¥{{ fenToYuan(info.frozen_amount) }}</div>
					</div>
					<div class="money-item">
						<div class="label">可用额度</div>
						<div class="value">¥{{ fenToYuan(info.available_amount) }}</div>
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-title">仓内业务</div>
				<div class="entry-list">
					<div class="entry" @click="goPos">POS 销售</div>
					<div class="entry" @click="goGoods">商品列表</div>
					<div class="entry" @click="goBuyout">变现报价</div>
					<div class="entry" @click="goSale">销售记录</div>
					<div class="entry" @click="goEntry">入仓管理</div>
					<div class="entry" @click="goExit">取回管理</div>
					<div class="entry" @click="goPromotion">折上折</div>
					<div class="entry" @click="goStocktaking">盘点</div>
				</div>
			</div>

			<div class="card danger-card">
				<div class="card-title">关闭云仓</div>
				<div class="close-desc">关闭后仓位终止、不可恢复。须先清空在仓库存、冻结货值和在途入仓/取回/盘点单。剩余保证金将全额退还账户余额。</div>
				<el-button type="danger" size="small" :loading="closing" @click="openClose">关闭云仓</el-button>
			</div>
		</div>

		<el-dialog title="补充保证金" :visible.sync="rechargeShow" width="480px" :before-close="closeRecharge">
			<div class="forms" v-if="rechargeShow">
				<el-form ref="rechargeForm" :model="rechargeForm" :rules="rechargeRules" label-width="110px">
					<el-form-item label="当前保证金">
						<div>¥{{ fenToYuan(info.deposit_amount) }}</div>
					</el-form-item>
					<el-form-item label="账户余额">
						<div>{{ balanceText }} 元</div>
					</el-form-item>
					<el-form-item label="补充金额" prop="amount_yuan">
						<el-input v-model="rechargeForm.amount_yuan" placeholder="请输入补充金额">
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeRecharge">取消</el-button>
				<el-button type="primary" :loading="recharging" @click="onRecharge">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="修改默认加价折扣" :visible.sync="markupShow" width="460px" :before-close="closeMarkup">
			<div class="forms" v-if="markupShow">
				<el-form label-width="110px">
					<el-form-item label="加价折扣">
						<el-input v-model="markupForm.markup_discount" placeholder="0~10，如 2 表示加 2 折">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<div class="markup-tip">售价 = 吊牌价 × (综合拿货折扣 + 加价折扣) ÷ 10；0 = 不加价；仅对未单独设置的商品生效。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeMarkup">取消</el-button>
				<el-button type="primary" :loading="markupSaving" @click="onSaveMarkup">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, yuanToFen, apiMsg, formatMarkupDiscount } from './money.js'

	export default {
		name: 'WarehouseIndex',
		inject: ['appdata'],
		data() {
			var checkAmount = (rule, value, callback) => {
				var num = parseFloat(value)
				if (value === '' || value === null || value === undefined) {
					callback(new Error('请输入补充金额'))
					return
				}
				if (isNaN(num) || num <= 0) {
					callback(new Error('充值金额必须大于0'))
					return
				}
				callback()
			}
			return {
				ready: false,
				apply: {},
				info: {},
				canceling: false,
				rechargeShow: false,
				recharging: false,
				rechargeForm: {
					amount_yuan: ''
				},
				markupShow: false,
				markupSaving: false,
				markupForm: {
					markup_discount: ''
				},
				closing: false,
				rechargeRules: {
					amount_yuan: [{
						required: true,
						validator: checkAmount,
						trigger: 'blur'
					}]
				}
			}
		},
		computed: {
			hasApply() {
				return !!(this.apply && this.apply.id)
			},
			displayDepositFen() {
				return this.apply.apply_deposit_amount != null
					? this.apply.apply_deposit_amount
					: this.apply.deposit_amount
			},
			depositRefundTip() {
				return (this.apply.state == 3 || this.apply.state == 4 || this.apply.state == 5) ? '（已退回账户余额）' : ''
			},
			balanceText() {
				var money = this.appdata && this.appdata.myinfo ? this.appdata.myinfo.money : ''
				return money === 0 || money ? money : '--'
			}
		},
		mounted() {
			if (this.$route.query.apply_no) {
				this.$router.replace({
					path: '/buyer/warehouse/exit',
					query: { apply_no: this.$route.query.apply_no }
				})
				return
			}
			this.loadApply()
		},
		methods: {
			fenToYuan: fenToYuan,
			formatMarkupDiscount: formatMarkupDiscount,
			goApply() {
				this.$router.push('/buyer/warehouse/apply')
			},
			goLog() {
				this.$router.push('/buyer/warehouse/deposit_log')
			},
			goEntry() {
				this.$router.push('/buyer/warehouse/entry')
			},
			goExit() {
				this.$router.push('/buyer/warehouse/exit')
			},
			goPos() {
				this.$router.push('/buyer/warehouse/pos')
			},
			goSale() {
				this.$router.push('/buyer/warehouse/sale')
			},
			goGoods() {
				this.$router.push('/buyer/warehouse/goods')
			},
			goBuyout() {
				this.$router.push('/buyer/warehouse/buyout')
			},
			goPromotion() {
				this.$router.push('/buyer/warehouse/promotion')
			},
			goStocktaking() {
				this.$router.push('/buyer/warehouse/stocktaking')
			},
			refreshBalance() {
				if (this.appdata && this.appdata.oninfo) {
					this.appdata.oninfo()
				}
			},
			loadApply() {
				this.$axios.get('api/cloud_warehouse/my_application').then(res => {
					if (res.data.code === 0) {
						this.apply = res.data.data || {}
						this.ready = true
						if (this.apply.id && this.apply.state == 2) {
							this.loadInfo()
						} else {
							this.info = {}
						}
					} else {
						this.ready = true
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.ready = true
					console.log(err)
				})
			},
			loadInfo() {
				this.$axios.get('api/cloud_warehouse/info').then(res => {
					if (res.data.code === 0) {
						this.info = res.data.data || {}
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			onCancel() {
				this.$confirm('撤回后保证金将退回账户余额', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.canceling = true
					this.$axios.post('api/cloud_warehouse/cancel_apply', {
						id: this.apply.id
					}).then(res => {
						this.canceling = false
						if (res.data.code === 0) {
							this.$message.success('已撤回申请，保证金已退回账户余额')
							this.refreshBalance()
							this.loadApply()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.canceling = false
						console.log(err)
					})
				}).catch(() => {})
			},
			openRecharge() {
				this.rechargeForm.amount_yuan = ''
				this.rechargeShow = true
				this.$nextTick(() => {
					if (this.$refs.rechargeForm) {
						this.$refs.rechargeForm.clearValidate()
					}
				})
			},
			closeRecharge() {
				this.rechargeShow = false
				this.rechargeForm.amount_yuan = ''
			},
			onRecharge() {
				this.$refs.rechargeForm.validate((valid) => {
					if (!valid) {
						return
					}
					this.recharging = true
					this.$axios.post('api/cloud_warehouse/deposit_recharge', {
						amount: yuanToFen(this.rechargeForm.amount_yuan)
					}).then(res => {
						this.recharging = false
						if (res.data.code === 0) {
							this.$message.success('补充保证金成功')
							this.closeRecharge()
							this.refreshBalance()
							this.loadApply()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
					this.recharging = false
					console.log(err)
					})
				})
			},
			openMarkup() {
				this.markupForm.markup_discount = this.info.markup_discount != null ? String(this.info.markup_discount) : '2'
				this.markupShow = true
			},
			closeMarkup() {
				this.markupShow = false
			},
			openClose() {
				var amount = this.fenToYuan(this.info.deposit_amount)
				this.$confirm('关闭后仓位终止、不可恢复。剩余保证金 ¥' + amount + ' 将全额退还至账户余额。', '关闭云仓', {
					confirmButtonText: '确认关闭',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.closing = true
					this.$axios.post('api/cloud_warehouse/close', {
						id: this.info.id
					}).then(res => {
						this.closing = false
						if (res.data.code === 0) {
							var refund = (res.data.data && res.data.data.refund_amount) || amount
							this.$message.success('云仓已关闭，保证金 ¥' + refund + ' 已退还账户余额')
							this.refreshBalance()
							this.loadApply()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.closing = false
						console.log(err)
					})
				}).catch(() => {})
			},
			onSaveMarkup() {
				var num = parseFloat(this.markupForm.markup_discount)
				if (this.markupForm.markup_discount === '' || isNaN(num) || num < 0 || num > 10) {
					this.$message.warning('请输入 0~10 的加价折扣（如 2 表示加 2 折）')
					return
				}
				this.markupSaving = true
				this.$axios.post('api/cloud_warehouse/set_markup', {
					warehouse_id: this.info.id,
					markup_discount: num
				}).then(res => {
					this.markupSaving = false
					if (res.data.code === 0) {
						this.$message.success('已更新默认加价折扣')
						this.markupShow = false
						this.loadInfo()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.markupSaving = false
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-index {
		padding: 10px 10px 20px;
	}

	.empty-guide {
		padding: 80px 20px;
		text-align: center;
		.empty-title {
			font-size: 20px;
			font-weight: 600;
			margin-bottom: 12px;
		}
		.empty-desc {
			color: #909399;
			margin-bottom: 24px;
		}
	}

	.status-card,
	.card {
		background: #fff;
		border: 1px solid #EBEEF5;
		border-radius: 4px;
		padding: 20px;
		margin-bottom: 16px;
	}

	.status-card.state-1 {
		border-color: #E6A23C;
	}
	.status-card.state-3 {
		border-color: #F56C6C;
	}
	.status-card.state-4,
	.status-card.state-5 {
		border-color: #C0C4CC;
	}

	.danger-card {
		border-color: #FDE2E2;
	}

	.close-desc {
		color: #909399;
		font-size: 13px;
		line-height: 20px;
		margin-bottom: 12px;
	}

	.status-head {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		.name {
			font-size: 16px;
			font-weight: 600;
			margin-right: 12px;
		}
	}

	.state-tag {
		padding: 2px 8px;
		border-radius: 2px;
		font-size: 12px;
		background: #f4f4f5;
		color: #909399;
	}
	.state-1 .state-tag {
		background: #fdf6ec;
		color: #E6A23C;
	}
	.state-2 .state-tag {
		background: #f0f9eb;
		color: #67C23A;
	}
	.state-3 .state-tag {
		background: #fef0f0;
		color: #F56C6C;
	}

	.status-row,
	.remark {
		line-height: 24px;
		color: #606266;
	}
	.remark {
		color: #F56C6C;
		margin-top: 8px;
	}
	.status-actions {
		margin-top: 16px;
	}

	.card-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 600;
		margin-bottom: 16px;
	}

	.info-grid {
		display: flex;
		flex-wrap: wrap;
		div {
			width: 50%;
			line-height: 28px;
			color: #303133;
			box-sizing: border-box;
			padding-right: 16px;
			span {
				display: inline-block;
				width: 80px;
				color: #909399;
			}
		}
	}

	.money-grid {
		display: flex;
	}
	.money-item {
		flex: 1;
		.label {
			color: #909399;
			margin-bottom: 8px;
		}
		.value {
			font-size: 22px;
			font-weight: 600;
			color: #F65730;
		}
	}

	.entry-list {
		display: flex;
	}
	.entry {
		flex: 1;
		height: 64px;
		margin-right: 12px;
		border: 1px dashed #DCDFE6;
		border-radius: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		color: #606266;
		&:last-child {
			margin-right: 0;
		}
		&:hover {
			border-color: #F65730;
			color: #F65730;
		}
	}

	.markup-tip {
		color: #909399;
		font-size: 12px;
		line-height: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/index.vue